// removed by extract-text-webpack-plugin
module.exports = {"logoContainer":"_1vCAa","logo":"_3HN73"};


//////////////////
// WEBPACK FOOTER
// ./components/icons/IDealIcon/IDealIcon.scss
// module id = 282
// module chunks = 0 1